import { Injectable } from '@angular/core';
import { RouterHistoryService } from '~/core/services/router-history/router-history.service';
import { Router } from '@angular/router';

enum MOBILE_NAVIGATOR {
  WINDOWS = 'windows_phone',
  ANDROID = 'android',
  IOS = 'ios',
  UNKNOWN = 'unknown',
}

@Injectable()
export class NavigatorService {
  constructor(
    public readonly routerHistory: RouterHistoryService,
    private readonly router: Router
  ) {}

  public get isAndroid(): boolean {
    return this.mobileOperatingSystem === MOBILE_NAVIGATOR.ANDROID;
  }

  public get isIOS(): boolean {
    return this.mobileOperatingSystem === MOBILE_NAVIGATOR.IOS;
  }
  public get mobileOperatingSystem(): MOBILE_NAVIGATOR {
    const userAgent = navigator.userAgent || '';
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return MOBILE_NAVIGATOR.WINDOWS;
    }
    if (/android/i.test(userAgent)) {
      return MOBILE_NAVIGATOR.ANDROID;
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return MOBILE_NAVIGATOR.IOS;
    }
    return MOBILE_NAVIGATOR.UNKNOWN;
  }

  public buildUrlTree(): void {
    if (
      (this.routerHistory?.previous &&
        this.routerHistory?.previous?.split('?')[0] !==
          this.routerHistory?.current?.split('?')[0]) ||
      !window.location.search
    ) {
      const urlTree = this.router.createUrlTree([], {
        queryParams: { page: '1' },
        queryParamsHandling: 'merge',
      });

      this.router.navigateByUrl(urlTree);
    }
  }
}
